module.exports = __webpack_public_path__ + "img/Asset-207-100.c703756d.jpg";